<template>
    <div class="swiperwrap" v-finger:swipe="touchswipe" @mouseover="stop=true" @mouseout="stop=false">
        <ul class="swiperbg">
            <li v-for="item in infolist" :key="item.id">
                <template v-if="c_options.type=='image'">
                    <img :src="item.img" class="swiperimg" />
                </template>
                <template v-else>
                    <div :class="csscon" v-html="$common.langinfo(item.content,item.content_en)"></div>
                </template>
            </li>
        </ul>
        <transition-group :name="tranname" tag="ul" class="swiperbox">
            <li v-for="(item,index) in infolist" :key="item.id" v-show="index==c_indexcur">
                <template v-if="c_options.type=='image'">
                    <img :src="item.img" class="swiperimg" />
                </template>
                <template v-else>
                    <div :class="csscon" v-html="$common.langinfo(item.content,item.content_en)"></div>
                </template>
            </li>

        </transition-group>
    </div>

</template>

<script>
    export default {
        name: 'ffswiper',
        data() {
            return {
                stop: false,
                myinterval: '',
                optionsdefault: {
                    'type': 'image', 'isautoplay': true, 'duration': 3000
                }
            }
        },
        props: {
            infolist: {
                type: Array,
                default: () => []
            },
            options: {
                type: Object,
                default: () => { }
            },
            indexcur: {
                type: Number,
                default: 0
            },
            direct: {
                type: Number,
                default: 1
            },
            csscon: {
                type: String,
                default: 'editor'
            }
        },
        computed: {
            c_options: function () {
                return Object.assign({}, this.optionsdefault, this.options);
            },
            itemmax: function () {
                return this.infolist.length;
            },
            c_indexcur: function () {
                let _indexcur = this.indexcur >= this.itemmax ? 0 : this.indexcur < 0 ? this.itemmax - 1 : this.indexcur;
                if (_indexcur != this.indexcur) { this.updateindexcur(_indexcur); }

                return _indexcur;
            },
            tranname: function () {
                return this.direct == 1 ? 'swiperleft' : this.direct == 2 ? 'swiperright' : this.direct == 3 ? 'swiperup' : this.direct == 4 ? 'swiperdown' : '';
            }
        },
        methods: {
            updateindexcur: function (v, direct) {
                this.$emit('update:indexcur', v);
                if (direct != undefined) {
                    this.$emit('update:direct', direct);
                }
            },
            autoplay: function () {
                if (this.stop) {
                    let vm = this;
                    this.myinterval = window.setInterval(function () {
                        if ((!vm.c_options.isstop) && (!vm.stop)) {
                            vm.updateindexcur(vm.c_indexcur + 1);
                        }
                    }, vm.c_options.duration);
                }
            },
            touchswipe: function (e) {
                if (e.direction == "Left") {
                    this.updateindexcur(this.c_indexcur + 1, 1);
                }
                else {
                    if (e.direction == "Right") {
                        this.updateindexcur(this.c_indexcur - 1, 2);
                    }
                }
            }
        },
        beforeDestroy() {
            window.clearInterval(this.myinterval);
        },
        mounted() {
            this.autoplay();
        }
    }
</script>
